




































































import Vue from "vue";
import ThemeTextField from "@/components/molecules/ThemeTextField.vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";
import { callApi } from "@/lib/api";
import { showNotifyDialog } from "@/lib/dialog";
import { Detail } from "@/lib/models/theme";
import clone from "lodash/cloneDeep";
import deepEqual from "deep-equal";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { ThemeTextField, ButtonDefault },
  props: {
    novelId: String,
  },
  data() {
    return {
      preTheme: {},
      theme: {},
    };
  },
  async created() {
    const { novelId } = this;
    const Theme = `query Theme ($novelId: ID!) {
      theme(novelId: $novelId){
        novelId
        detail { name value }
      }
    }`;
    const { theme } = await callApi(Theme, { novelId });
    if (theme.detail) {
      const detail: Theme = {};
      (theme.detail as Detail[]).forEach((item) => {
        detail[item.name] = item.value;
      });
      this.theme = detail;
      this.preTheme = clone(detail);
    }
  },
  computed: {
    isValidWordLength() {
      const { theme } = this;
      if (Object.prototype.hasOwnProperty.call(theme, "word-length") && Number.isNaN(theme["word-length"])) {
        return false;
      }
      return true;
    },
    changed() {
      return !deepEqual(this.preTheme, this.theme);
    },
  },
  methods: {
    change() {
      this.setModified(true);
    },
    async submit() {
      const { novelId, theme, changed } = this;

      if (!changed) return;

      if (!this.isValidWordLength) {
        await showNotifyDialog({
          title: "入力エラー",
          content: "執筆予定文字数は半角数字で入力してください。",
        });
        return;
      }

      const detail = Object.keys(theme).map((key) => {
        return {
          name: key,
          value: theme[key],
        };
      });

      const input = {
        input: {
          novelId,
          detail,
        },
      };
      const UpdateTheme = `mutation UpdateTheme ($input: UpdateThemeInput!) {
        updateTheme(input: $input){
          novelId
          detail { name value }
        }
      }`;
      await callApi(UpdateTheme, input);

      this.$notify({
        title: "保存しました",
        type: "success",
      });

      this.setModified(false);
      this.preTheme = clone(theme);
    },
  },
});

interface Props {
  novelId: string;
}

interface Data {
  theme: Theme;
  preTheme: Theme;
}

interface Computed {
  isValidWordLength: boolean;
  changed: boolean;
}

interface Methods {
  change(): void;
  submit(): void;
}

type Theme = {
  [key: string]: string;
};
